export default __webpack_public_path__ + "static/media/Rental.6c01b34c.svg";